module.exports = __webpack_public_path__ + "img/American-Express-Logo.197dfe02.svg";